import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MaskOptions } from '../../models/form-input';

@Component({
  selector: 'basic-input',
  templateUrl: './basic-input.component.html',
  styleUrls: ['./basic-input.component.scss']
})
export class BasicInputComponent implements OnInit {

  @Input() id!: string;
  @Input() formGroup!: FormGroup | any;
  @Input() placeholder!: string;
  @Input() label!: string;
  @Input() labelPosition: string = 'top';
  @Input() maskOptions!: MaskOptions;
  @Input() removeVerticalSpacing: boolean = false;
  @Input() capitalize: boolean = false;
  @Input() showError: boolean = true;
  @Input() dropSpecialCharacters: boolean = true;
  @Input() focusout? = new EventEmitter;

  constructor() { }

  ngOnInit(): void {
  }

  focusOut(e: any) {
    this.focusout?.emit(e);
  }

  checkKey(e: any) {
    if (this.capitalize) {
      var regex = new RegExp("^[a-zA-Z0-9 ]+$");
      var str = String.fromCharCode(!e.charCode ? e.which : e.charCode);
      if (regex.test(str)) {
        return true;
      }

      e.preventDefault();
      return false;
    } else {
      return true;
    }
  }
}
